// extracted by mini-css-extract-plugin
export var button = "button-module--button--X-qXA";
export var yellow = "button-module--yellow--RwlWv";
export var purple = "button-module--purple--t3ijN";